"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "useTagAvatarContextValues_unstable", {
    enumerable: true,
    get: function() {
        return _useTagAvatarContextValues.useTagAvatarContextValues_unstable;
    }
});
const _useTagAvatarContextValues = require("./useTagAvatarContextValues");
